import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { FooterComponent } from '../../../template-components/footer/footer.component';
import { HeaderComponent } from '../../../template-components/header/header.component';
import { SidebarComponent } from '../../../template-components/sidebar/sidebar.component';

@Component({
    selector: 'app-dashboard',
    imports: [RouterOutlet, HeaderComponent, SidebarComponent, FooterComponent, NgScrollbarModule],
    templateUrl: './dashboard.component.html',
    styleUrl: './dashboard.component.scss'
})
export class DashboardComponent {}